import React from "react";
import "./DND.scss";
import { DragDropReactContext } from "dnd/DragDropContext";

export const DroppableContext = React.createContext({});

export class Droppable extends React.Component {
  static contextType = DragDropReactContext;
  state = { draggingOver: false, firstAfterIndex: 0 };
  draggables = {};
  innerRef = React.createRef();
  animFrame = 0;
  animRequested = false;
  componentDidMount = () => {
    this.context.registerDroppable(this);
  };
  registerChild = (index, draggable) => {
    this.draggables[index] = draggable;
  };

  draggablesMap = (callback) => {
    Object.values(this.draggables).map(d => {
      if (!d.innerRef.current) return;
      callback(d, d.innerRef.current);
    });
  };
  update = (callback) => {
    if (!this.animRequested) return;
    const { type, vertical = true } = this.props;
    const dragging = this.context.dragging;
    if (dragging) {
      if (dragging.props.type === type) {
        const mouse = dragging.mouse;
        const isAfter = (e, index) => {
          const rect = e.getBoundingClientRect();
          return (
            index > firstAfterIndex &&
            (vertical
              ? (rect.top + rect.bottom) / 2 < mouse[1]
              : (rect.left + rect.right) / 2 < mouse[0])
          );
        };
        let firstAfterIndex = 0;
        this.draggablesMap((v, e) => {
          if (v === dragging) return;
          const index = v.props.index + 1;
          if (isAfter(e, index)) {
            firstAfterIndex = index;
          }
        });
        if (!this.state.draggingOver || this.state.firstAfterIndex !== firstAfterIndex) {
          this.context.updateDropResult(this, firstAfterIndex);
          this.setState({ draggingOver: true, firstAfterIndex }, callback);
        } else callback && callback();
      }
    } else if (this.state.draggingOver) this.setState({ draggingOver: false });
    this.animFrame = requestAnimationFrame(() => this.update());
  };
  beginListening = (callback) => {
    if (!this.animRequested) {
      this.animRequested = true;
      this.update(callback);
    }
  };
  endListening = () => {
    this.animRequested = false;
    cancelAnimationFrame(this.animFrame);
    this.setState({ draggingOver: false, firstAfterIndex: -1 });
  };
  render = () => {
    let placeholder = null;
    let dragOverShuffle = [0, 0];
    const { vertical = true } = this.props;
    if (this.context.dragging != null && this.context.dragging.props.type === this.props.type) {
      const dims = this.context.dragging.dims;
      placeholder = <div style={{ minWidth: `${dims[0]}px`, minHeight: `${dims[1]}px` }} />;
      dragOverShuffle = [vertical ? 0 : dims[0], vertical ? dims[1] : 0];
    }
    return (
      <DroppableContext.Provider
        value={{
          source: this,
          registerDraggable: this.registerChild,
          firstAfterIndex: this.state.firstAfterIndex,
          draggingOver: this.state.draggingOver,
          dragOverShuffle,
          ...this.context
        }}
      >
        {this.props.children(
          {
            placeholder,
            droppableProps: {
              ref: this.innerRef
            }
          },
          this.state
        )}
      </DroppableContext.Provider>
    );
  };
}

export default Droppable;
